import { Text, type TextProps, useMantineTheme } from "@mantine/core";
import React from "react";

import styles from "./ReviewsTable.module.scss";

interface ReviewTextProps extends TextProps {
  blue?: boolean | string | null;
  red?: boolean | string | null;
  green?: boolean | string | null;
  disabled?: boolean;
  color?: string;
}

export const ReviewText: React.FC<ReviewTextProps> = ({
  blue,
  red,
  green,
  disabled,
  color: propColor,
  className,
  style,
  ...rest
}) => {
  const theme = useMantineTheme();
  let color = propColor || "";
  const colorStr = typeof color === "string" ? color : "";
  const isBlue = blue ?? colorStr === "blue";
  const isRed = red ?? colorStr === "red";
  const isGreen = green ?? colorStr === "green";

  if (isBlue) {
    color = theme.colors.settingsColor[0];
  } else if (isRed) {
    color = theme.colors.redText[0];
  } else if (isGreen) {
    color = "green.9";
  } else if (disabled) {
    color = theme.colors.grayText[0];
  }

  return (
    <Text
      component="span"
      className={className}
      c={color}
      style={{ ...style }}
      {...rest}
    />
  );
};

export const StatusGoldCircle: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.statusGoldCircle} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
